import { ElementRef, HostListener, ViewChild } from "@angular/core";

export abstract class BaseDashboardPage {
    
    @ViewChild('fullscreenElement') elementRef!: ElementRef;

    public fullscreenEnabled: boolean = false;

    openFullscreen() {
        const element = this.elementRef.nativeElement;

        if (element.requestFullscreen) {
            element.requestFullscreen();
        } 
        else if ((element as any).webkitRequestFullscreen) { // Для Safari
            (element as any).webkitRequestFullscreen();
        } 
        else if ((element as any).msRequestFullscreen) { // Для IE/Edge
            (element as any).msRequestFullscreen();
        }

        this.fullscreenEnabled = true;
    }

    closeFullscreen() {
        if (document && document.exitFullscreen) {
            document.exitFullscreen();
        } 
        else if ((document as any).webkitExitFullscreen) { // Для Safari
            (document as any).webkitExitFullscreen();
        } 
        else if ((document as any).msExitFullscreen) { // Для IE/Edge
            (document as any).msExitFullscreen();
        }

        this.fullscreenEnabled = false;
    }
}